import { Component, Input, OnInit } from '@angular/core';
import { Faq } from '@generated/graphql';
import { FaqContentfulListComponent } from '../faq-contentful-list/faq-contentful-list.component';

@Component({
    selector: 'app-faq-contentful-section',
    templateUrl: './faq-contentful-section.component.html',
    imports: [FaqContentfulListComponent],
})
export class FaqContentfulSectionComponent implements OnInit {
    @Input() faqs: Faq[] = [];

    ngOnInit(): void {}
}
